<template>
  <div class="data-table">
    <div class="table-container">
      <table class="table" aria-label="Sector stocks">
        <thead>
          <tr class="header-row">
            <th class="header-cell" role="columnheader" scope="col">Indices</th>
            <th class="header-cell header-cell--sortable" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderIndexTable('index_ticker')">
                <div class="header-cell-label">Nombre</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'index_ticker'}">
                  <span class="material-icons">{{ getSortIcon('index_ticker') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--sortable" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderIndexTable('pais')">
                <div class="header-cell-label">País</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'pais'}">
                  <span class="material-icons">{{ getSortIcon('pais') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--sortable header-cell--numeric" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderIndexTable('m1')">
                <div class="header-cell-label">Corto</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'm1'}">
                  <span class="material-icons">{{ getSortIcon('m1') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--sortable header-cell--numeric" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderIndexTable('m3')">
                <div class="header-cell-label">Medio</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'm3'}">
                  <span class="material-icons">{{ getSortIcon('m3') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--sortable header-cell--numeric" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderIndexTable('y1')">
                <div class="header-cell-label">Largo</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'y1'}">
                  <span class="material-icons">{{ getSortIcon('y1') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--numeric" role="columnheader" scope="col">Valores</th>
            <th class="header-cell" role="columnheader" scope="col">Gráfico</th>
          </tr>
        </thead>
        <tbody class="table-content">
          <tr class="table-row" v-for="(exchange, index) in displayIndices" :key="exchange.index_ticker || `${getTranslatedCountryName(exchange.pais)}-${exchange.exchange}-${index}`">
            <td class="table-cell sector-name"><strong>{{ exchange.exchange }}</strong></td>
            <td class="table-cell sector-name"><strong>{{ exchange.index_ticker }}</strong></td>
            <td class="table-cell sector-name">{{ getTranslatedCountryName(exchange.pais) }}</td>
            <td class="table-cell table-cell--numeric" :class="getValueClass(exchange.m1)">{{exchange.m1}}</td>
            <td class="table-cell table-cell--numeric" :class="getValueClass(exchange.m3)">{{exchange.m3}}</td>
            <td class="table-cell table-cell--numeric" :class="getValueClass(exchange.y1)">{{exchange.y1}}</td>
            <td class="table-cell table-cell--numeric">{{exchange.total}}</td>
            <td class="table-cell options">
              <button class="action-button" @click.prevent="_userPermissionShowStockchart(exchange.exchange)" aria-label="Show chart">
                <span class="material-icons">show_chart</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'TableIndex',
  props: {
    indices_data: Object, // Expected: { countryName: [exchangeObj, ...], ... }
  },
  data: () => ({
    sort: {
      column: 'm1', // Default sort column
      order: 'asc'   // Default sort order
    },
    displayIndices: [], // This will hold the flattened, sortable list of exchanges
    countryTranslations: { // Copied from Indices.vue
      'United States': 'Estados Unidos',
      'USA': 'Estados Unidos',
      'US': 'Estados Unidos',
      'United Kingdom': 'Reino Unido',
      'UK': 'Reino Unido',
      'GB': 'Reino Unido',
      'Germany': 'Alemania',
      'DE': 'Alemania',
      'France': 'Francia',
      'FR': 'Francia',
      'Spain': 'España',
      'ES': 'España',
      'Italy': 'Italia',
      'IT': 'Italia',
      'Netherlands': 'Países Bajos',
      'NL': 'Países Bajos',
      'Canada': 'Canadá',
      'CA': 'Canadá',
      'Brazil': 'Brasil',
      'BR': 'Brasil',
      'Mexico': 'México',
      'MX': 'México',
      'Russia': 'Rusia',
      'RU': 'Rusia',
      'China': 'China',
      'CN': 'China',
      'Japan': 'Japón',
      'JP': 'Japón',
      'India': 'India',
      'IN': 'India',
      'Australia': 'Australia',
      'AU': 'Australia',
      'South Korea': 'Corea del Sur',
      'KR': 'Corea del Sur',
      'South Africa': 'Sudáfrica',
      'ZA': 'Sudáfrica',
      'Switzerland': 'Suiza',
      'CH': 'Suiza',
      'Sweden': 'Suecia',
      'SE': 'Suecia',
      'Norway': 'Noruega',
      'NO': 'Noruega',
      'Denmark': 'Dinamarca',
      'DK': 'Dinamarca',
      'Finland': 'Finlandia',
      'FI': 'Finlandia',
      'Belgium': 'Bélgica',
      'BE': 'Bélgica',
      'Austria': 'Austria',
      'AT': 'Austria',
      'Poland': 'Polonia',
      'PL': 'Polonia',
      'Portugal': 'Portugal',
      'PT': 'Portugal',
      'Greece': 'Grecia',
      'GR': 'Grecia',
      'Ireland': 'Irlanda',
      'IE': 'Irlanda',
      'New Zealand': 'Nueva Zelanda',
      'NZ': 'Nueva Zelanda',
      'Singapore': 'Singapur',
      'SG': 'Singapur',
      'Hong Kong': 'Hong Kong',
      'HK': 'Hong Kong',
      'Taiwan': 'Taiwán',
      'TW': 'Taiwán',
      'Israel': 'Israel',
      'IL': 'Israel',
      'Turkey': 'Turquía',
      'TR': 'Turquía',
      'Indonesia': 'Indonesia',
      'ID': 'Indonesia',
      'Thailand': 'Tailandia',
      'TH': 'Tailandia',
      'Malaysia': 'Malasia',
      'MY': 'Malasia',
      'Philippines': 'Filipinas',
      'PH': 'Filipinas',
      'Hungary': 'Hungría',
      'HU': 'Hungría',
      'Czech Republic': 'República Checa',
      'CZ': 'República Checa',
      'Chile': 'Chile',
      'CL': 'Chile',
      'Argentina': 'Argentina',
      'AR': 'Argentina',
      'Colombia': 'Colombia',
      'CO': 'Colombia',
      'Peru': 'Perú',
      'PE': 'Perú',
      'GB': 'Gran Bretaña',
      'England': 'Gran Bretaña',
      'Singapoore': 'Singapur', // Corrected typo from Indices.vue (Singapoore -> Singapore)
      'XIST': 'Estanbul',
      'Istanbul': 'Estanbul'
    }
  }),
  computed: {
    flattenedIndices() {
      const flatList = [];
      if (this.indices_data && typeof this.indices_data === 'object') {
        Object.values(this.indices_data).forEach(countryExchanges => {
          if (Array.isArray(countryExchanges)) {
            countryExchanges.forEach(exchange => {
              flatList.push(exchange);
            });
          }
        });
      }
      return flatList;
    }
  },
  watch: {
    flattenedIndices: {
      immediate: true, // Run when component is created and prop is initially passed
      handler(newVal) {
        this.displayIndices = [...newVal]; // Make a mutable copy
        this._applySort(); // Apply the initial/current sort
      }
    }
  },
  methods: {
    _userPermissionShowStockchart(exchange) {
      this.$router.push('/app/graficador-dinamico/exchange/' + exchange);
    },
    _applySort() {
      if (!this.displayIndices || this.displayIndices.length === 0 || !this.sort.column) return;

      const columnToSortBy = this.sort.column;
      const currentOrder = this.sort.order;
      const isNumericColumn = ["m1", "m3", "y1", "total"].includes(columnToSortBy);

      this.displayIndices.sort((a, b) => {
        let valA = a[columnToSortBy];
        let valB = b[columnToSortBy];

        if (isNumericColumn) {
          valA = parseInt(valA, 10);
          valB = parseInt(valB, 10);
          if (isNaN(valA)) valA = currentOrder === "asc" ? Infinity : -Infinity; // Push NaNs to the end
          if (isNaN(valB)) valB = currentOrder === "asc" ? Infinity : -Infinity;
        } else {
          valA = String(valA || "").toLowerCase(); // Handle null/undefined for string sort
          valB = String(valB || "").toLowerCase();
        }
        
        let comparison = 0;
        if (valA < valB) {
          comparison = -1;
        } else if (valA > valB) {
          comparison = 1;
        }

        return currentOrder === "asc" ? comparison : comparison * -1;
      });
    },
    _orderIndexTable: function(columnToSortBy) {
      if (!this.displayIndices || this.displayIndices.length === 0) return;

      if (this.sort.column === columnToSortBy) {
        // Toggle order if same column is clicked
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        // New column, default to ascending sort
        this.sort.column = columnToSortBy;
        this.sort.order = "asc";
      }
      this._applySort(); // Apply the new sort settings
    },
    getSortIcon(column) {
      if (this.sort.column !== column) return 'unfold_more';
      return this.sort.order === 'asc' ? 'expand_less' : 'expand_more';
    },
    getValueClass(value) {
      const numValue = parseInt(value);
      if (numValue < 20) return 'value-red';
      if (numValue < 40) return 'value-orange';
      if (numValue < 60) return 'value-yellow';
      if (numValue < 80) return 'value-green';
      return 'value-blue';
    },
    getTranslatedCountryName(name) { // Copied from Indices.vue
      return this.countryTranslations[name] || name;
    }
  },
}
</script>

<style lang="scss" scoped>
  .data-table {
    width: 100%;
    border-radius: 8px;
    background-color: var(--color-surface);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 32px;
    overflow: hidden;
    border: 1px solid var(--color-outline);
    transition: all 0.2s ease;
  }

  .table-container {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--color-muted) var(--color-surface);
    
    &::-webkit-scrollbar {
      height: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: var(--color-surface);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: var(--color-muted);
      border-radius: 3px;
      border: 1px solid var(--color-surface);
    }
  }

  .table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    white-space: nowrap;
    font-size: 13px;
    table-layout: fixed;
  }

  .header-row {
    height: 44px;
    background-color: var(--color-background);
    border-bottom: 1px solid var(--color-outline);
  }

  .header-cell {
    color: var(--color-text-secondary);
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    padding: 0 12px;
    height: 44px;
    letter-spacing: 0.3px;
    font-size: 11px;
    transition: background-color 0.2s ease;
    vertical-align: middle;
    
    &:nth-child(1) { /* Indices */
      width: 12%;
      text-align: center;
    }
    
    &:nth-child(2) { /* Nombre */
      width: 25%;
      text-align: left;
    }
    
    &:nth-child(3) { /* País */
      width: 20%;
      text-align: left;
    }
    
    &:nth-child(4), /* Corto */
    &:nth-child(5), /* Medio */
    &:nth-child(6) { /* Largo */
      width: 10%;
    }
    
    &:nth-child(7) { /* Valores */
      width: 10%;
    }
    
    &:nth-child(8) { /* Gráfico */
      width: 8%;
      text-align: center;
    }

    &--numeric {
      text-align: center;
    }

    &--sortable {
      cursor: pointer;
      
      &:hover {
        background-color: var(--color-active-surface);
      }
    }
  }

  .header-cell-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    
    .header-cell:nth-child(2) & {
      justify-content: flex-start;
    }
    
    .header-cell:nth-child(3) & {
      justify-content: flex-start;
    }
  }

  .sort-indicator {
    display: flex;
    align-items: center;
    opacity: 0.6;
    margin-left: 4px;
    
    &.active {
      opacity: 1;
      color: var(--color-highlight);
    }
    
    .material-icons {
      font-size: 14px;
    }
  }

  .header-cell-label {
    flex-grow: 0;
  }

  .table-row {
    height: 40px;
    border-bottom: 1px solid var(--color-outline);
    transition: background-color 0.2s ease;
    
    &:nth-child(even) {
      background-color: rgba(0, 0, 0, 0.02);
    }
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: var(--color-active-surface);
    }
  }

  .table-cell {
    padding: 6px 12px;
    height: 40px;
    text-align: center;
    color: var(--color-text-primary);
    font-size: 13px;
    vertical-align: middle;
    
    &:nth-child(1) { /* Indices */
      text-align: center;
    }
    
    &:nth-child(2) { /* Nombre */
      text-align: left;
      white-space: normal;
      word-break: break-word;
    }
    
    &:nth-child(3) { /* País */
      text-align: left;
    }

    &--numeric {
      text-align: center;
      font-variant-numeric: tabular-nums;
      font-weight: 500;
    }
  }

  .sector-name {
    text-align: left;
    
    strong {
      color: var(--color-text-primary);
      font-weight: 600;
    }
  }

  .options {
    text-align: center;
  }

  .action-button {
    background: transparent;
    border: none;
    border-radius: 4px;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--color-text-secondary);
    transition: all 0.2s ease;
    margin: 0 auto;
    
    &:hover {
      background-color: var(--color-active-surface);
      color: var(--color-highlight);
    }
    
    &:active {
      transform: scale(0.95);
    }
    
    .material-icons {
      font-size: 16px;
    }
  }
  
  .value-red, .value-orange, .value-yellow, .value-green, .value-blue {
    color: var(--color-text-primary);
    font-weight: 600;
    position: relative;
    padding-left: 14px;
    
    &::before {
      content: "";
      position: absolute;
      left: 33%;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 2px;
    }
  }
  
  .value-red::before {
    background-color: #D90033;
  }
  
  .value-orange::before {
    background-color: #D96900;
  }
  
  .value-yellow::before {
    background-color: #D2D900;
  }
  
  .value-green::before {
    background-color: #00D953;
  }
  
  .value-blue::before {
    background-color: #00add9;
  }
</style>
